export default "__VITE_ASSET__Cttd$Nb0__"